import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TransferHeader from '../components/common/TransferHeader';
import PaymentRoute from '../components/common/PaymentRoute';
import NetworkItem from '../components/common/NetworkItem';
import TransferForm from '../components/common/TransferForm';

import ColombiaFlag from '../assets/images/country/colombia.png';
import MexicoFlag from '../assets/images/country/mexico.png';
import UsFlag from '../assets/images/country/us.png';
import CanadaFlag from '../assets/images/country/canada.png';
import EuropeFlag from '../assets/images/country/europe.png';
import AsiaFlag from '../assets/images/country/asia.png';
import ChinaFlag from '../assets/images/country/china.png';
import KoreaFlag from '../assets/images/country/korea.png';
import PhilippineFlag from '../assets/images/country/philippine.png';
import IndiaFlag from '../assets/images/country/india.png';
import IndonesiaFlag from '../assets/images/country/indonesia.png';
import MalasiaFlag from '../assets/images/country/malasia.png';
import SingaporeFlag from '../assets/images/country/singapore.png';
import ThailandFlag from '../assets/images/country/thailand.png';
import VietnamFlag from '../assets/images/country/vietnam.png';
import BrazilFlag from '../assets/images/country/brazil.png';

const COL_COUNTRY = {
  icon: ColombiaFlag,
  name: 'Colombia',
  paymentRoutes: [],
  currency: 'COP',
  isoCode3: 'COL',
};

/**
 * Enviar hub — mock v2 (04-enviar): 2 pasos (destino → cuenta lista/nueva).
 * TransferForm / offRamp / retiroCop / requestId 409 se mantienen intactos.
 */
export default function Transfer() {
  const navigate = useNavigate();

  // null | 'col' | 'ext' | 'flowex-panel' — destino paso 1
  const [dest, setDest] = useState(null);
  // 'saved' | 'new' — paso 2 para col/ext
  const [accountMode, setAccountMode] = useState('saved');
  // null = hub; 'international' = país/riel; 'form' = TransferForm
  const [phase, setPhase] = useState(null);
  const [preferNewAccount, setPreferNewAccount] = useState(false);

  const [country, setCountry] = useState({
    icon: '',
    name: '',
    paymentRoutes: [],
    currency: '',
    isoCode3: '',
  });
  const [paymentRoute, setPaymentRoute] = useState('');
  const [isAsia, setIsAsia] = useState(false);

  const countries = [
    { icon: ColombiaFlag, name: 'Colombia', paymentRoutes: [], currency: 'COP', isoCode3: 'COL' },
    { icon: MexicoFlag, name: 'México', paymentRoutes: ['SPEI'], currency: 'MXN', isoCode3: 'MEX' },
    { icon: UsFlag, name: 'Estados Unidos', paymentRoutes: ['ACH', 'WIRE'], currency: 'USD', isoCode3: 'USA' },
    { icon: CanadaFlag, name: 'Canadá', paymentRoutes: [], currency: 'CAD', isoCode3: 'CAN', disabled: true },
    { icon: EuropeFlag, name: 'Europa', paymentRoutes: ['SEPA'], currency: 'EUR', isoCode3: 'EUR' },
    { icon: BrazilFlag, name: 'Brasil', paymentRoutes: ['PIX'], currency: 'BRL', isoCode3: 'BRA' },
    { icon: AsiaFlag, name: 'Asia' },
    { icon: ChinaFlag, name: 'China', paymentRoutes: ['BIC/SWIFT', 'CNAPS'], currency: 'CNY', isoCode3: 'CHN' },
    { icon: KoreaFlag, name: 'Corea del sur', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'KRW', isoCode3: 'KOR' },
    { icon: PhilippineFlag, name: 'Filipinas', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'PHP', isoCode3: 'PHL' },
    { icon: IndiaFlag, name: 'India', paymentRoutes: [], currency: 'INR', isoCode3: 'IND', disabled: true },
    { icon: IndonesiaFlag, name: 'Indonesia', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'IDR', isoCode3: 'IDN' },
    { icon: MalasiaFlag, name: 'Malasia', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'MYR', isoCode3: 'MYS' },
    { icon: SingaporeFlag, name: 'Singapour', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'SGD', isoCode3: 'SGP' },
    { icon: ThailandFlag, name: 'Tailandia', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'THB', isoCode3: 'THA' },
    { icon: VietnamFlag, name: 'Vietnam', paymentRoutes: ['BIC/SWIFT', 'Código de banco'], currency: 'VND', isoCode3: 'VNM' },
  ];
  const countryData = isAsia ? countries.slice(7, 16) : countries.slice(0, 7);

  const onChangeCountry = (item) => {
    if (item.name == 'Asia') setIsAsia(true);
    else setCountry(item);
  };

  const paymentRouteDescription = (route) => {
    if (route == 'ACH') return 'Tarda entre y 1-2 días hábiles, costo X por transferencia.';
    if (route == 'WIRE') return 'Transferencia en el mismo día, costo X por transferencia';
    if (route == 'BIC/SWIFT') return 'Para transferencias internacionales';
    if (route == 'SEPA') return `Solo para transferencias dentro de la región ${country.name}`;
    if (route == 'PIX') return 'Transferencia instantánea via PIX a Brasil';
    return `Solo para transferencias locales dentro de ${country.name}.`;
  };

  const goBackFromForm = () => {
    setCountry({ icon: '', name: '', paymentRoutes: [], currency: '', isoCode3: '' });
    setPaymentRoute('');
    if (dest === 'col') {
      setPhase(null);
    } else {
      setPhase('international');
    }
  };

  const goBackToHub = () => {
    setPhase(null);
    setDest(null);
    setAccountMode('saved');
    setPreferNewAccount(false);
    setCountry({ icon: '', name: '', paymentRoutes: [], currency: '', isoCode3: '' });
    setPaymentRoute('');
    setIsAsia(false);
  };

  const startColombia = (mode) => {
    setPreferNewAccount(mode === 'new');
    setCountry(COL_COUNTRY);
    setPaymentRoute('');
    setPhase('form');
  };

  const startExterior = (mode) => {
    setPreferNewAccount(mode === 'new');
    setCountry({ icon: '', name: '', paymentRoutes: [], currency: '', isoCode3: '' });
    setPaymentRoute('');
    setIsAsia(false);
    setPhase('international');
  };

  // ── TransferForm (money path intact) ─────────────────────────────
  if (phase === 'form' && country.name) {
    if (!country.paymentRoutes.length || (country.paymentRoutes.length && paymentRoute)) {
      return (
        <TransferForm
          country={country}
          paymentRoute={paymentRoute}
          goBack={goBackFromForm}
          initialIsNewAccount={preferNewAccount}
        />
      );
    }
  }

  // ── Payment route picker ─────────────────────────────────────────
  if (phase === 'international' && country.name && country.paymentRoutes.length && !paymentRoute) {
    return (
      <div className="enviar-hub relative py-8 flex items-center justify-center px-4">
        <div className="enviar-hub__card w-full max-w-xl fx-glass rounded-[20px] p-6 space-y-6">
          <TransferHeader
            headerTitle={`Transferir a cuenta en ${country.name}`}
            description="Selecciona el método de transferencia"
            goBack={() => setCountry({ icon: '', name: '', paymentRoutes: [], currency: '', isoCode3: '' })}
          />
          <div className="space-y-2">
            {country.paymentRoutes.map((route, idx) => (
              <PaymentRoute
                key={idx}
                route={route}
                description={paymentRouteDescription(route)}
                onClick={() => {
                  setPaymentRoute(route);
                  setPhase('form');
                }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  // ── Country picker (exterior) ────────────────────────────────────
  if (phase === 'international') {
    return (
      <div className="enviar-hub relative py-8 flex items-center justify-center px-4">
        <div className="enviar-hub__card w-full max-w-xl fx-glass rounded-[20px] p-6 space-y-6">
          <TransferHeader
            headerTitle={`Transferir${isAsia ? ' a Asia' : ''}`}
            description={isAsia ? 'Selecciona el país de destino' : 'Selecciona la región de destino'}
            goBack={() => {
              if (isAsia) setIsAsia(false);
              else goBackToHub();
            }}
          />
          <div className="space-y-2 pb-6">
            {countryData.map((item, idx) => (
              <NetworkItem
                key={idx}
                item={item}
                onClick={() => {
                  if (item.name === 'Asia') {
                    setIsAsia(true);
                    return;
                  }
                  onChangeCountry(item);
                  if (!item.paymentRoutes?.length) {
                    setPhase('form');
                  }
                }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  // ── Hub: Paso 1 + Paso 2 ────────────────────────────────────────
  const needsStep2 = dest === 'col' || dest === 'ext';
  const step2On = needsStep2;

  return (
    <div className="enviar-hub px-4 sm:px-6 lg:px-8 py-6 sm:py-8 pb-20 sm:pb-8 max-w-5xl mx-auto">
      <div className="enviar-hub__greet">
        <h1>Enviar</h1>
        <p>Dos pasos claros: primero el destino, luego la cuenta. Sin sorpresas de comisión.</p>
      </div>

      <div className="enviar-hub__step-rail" aria-label="Pasos">
        <div className={`enviar-hub__step-pill ${!step2On || dest ? 'on' : ''}`}>
          <span className="n">1</span> ¿A dónde?
        </div>
        <span className="enviar-hub__step-sep">→</span>
        <div className={`enviar-hub__step-pill ${step2On ? 'on' : 'dim'}`}>
          <span className="n">2</span> ¿Cuenta lista o nueva?
        </div>
      </div>

      <section className="enviar-hub__step-block">
        <h2 className="enviar-hub__step-heading">Paso 1 · ¿A dónde envías?</h2>
        <div className="enviar-hub__path-grid">
          <button
            type="button"
            className={`enviar-hub__path-card featured ${dest === 'flowex' ? 'selected' : ''}`}
            onClick={() => {
              setDest('flowex');
              navigate('/dashboard/send');
            }}
          >
            <span className="path-badge">GRATIS</span>
            <div className="path-title">Otro Flowex</div>
            <div className="path-desc">Por email. Llega al instante. Comisión $0.</div>
            <div className="path-meta">USDC · SMS antes de confirmar</div>
          </button>

          <button
            type="button"
            className={`enviar-hub__path-card ${dest === 'col' ? 'selected' : ''}`}
            onClick={() => {
              setDest('col');
              setAccountMode('saved');
            }}
          >
            <span className="path-badge fee">Colombia</span>
            <div className="path-title">Banco en Colombia</div>
            <div className="path-desc">Pesos nativos sin costo. Si sales desde USD, hay conversión.</div>
            <div className="path-meta">Nequi · Bancolombia · Davivienda · más</div>
          </button>

          <button
            type="button"
            className={`enviar-hub__path-card ${dest === 'ext' ? 'selected' : ''}`}
            onClick={() => {
              setDest('ext');
              setAccountMode('saved');
            }}
          >
            <span className="path-badge fee">Exterior</span>
            <div className="path-title">Banco en el exterior</div>
            <div className="path-desc">USA, Europa, México o Brasil con rieles locales.</div>
            <div className="path-meta">ACH · WIRE · SEPA · SPEI · PIX</div>
          </button>
        </div>
      </section>

      {dest === 'col' && (
        <section className="enviar-hub__step-block">
          <h2 className="enviar-hub__step-heading">Paso 2 · ¿Cuenta lista o nueva?</h2>
          <p className="enviar-hub__step-sub">Banco en Colombia · elige una cuenta guardada o registra una nueva.</p>

          <div className="enviar-hub__fee-strip">
            <div className="enviar-hub__fee-chip free">Desde COP · retiro nativo <strong>gratis</strong></div>
            <div className="enviar-hub__fee-chip">Desde USD · aplica <strong>conversión</strong> (no es retiro nativo)</div>
          </div>

          <div className="enviar-hub__choice-toggle" role="tablist" aria-label="Tipo de cuenta">
            <button
              type="button"
              className={`enviar-hub__choice ${accountMode === 'saved' ? 'on' : ''}`}
              onClick={() => setAccountMode('saved')}
            >
              Usar cuenta registrada
            </button>
            <button
              type="button"
              className={`enviar-hub__choice ${accountMode === 'new' ? 'on' : ''}`}
              onClick={() => setAccountMode('new')}
            >
              Registrar cuenta nueva
            </button>
          </div>

          <div className="enviar-hub__panel fx-glass">
            <h3>{accountMode === 'saved' ? 'Tus cuentas en Colombia' : 'Registrar cuenta Colombia'}</h3>
            <p className="enviar-hub__hint">
              {accountMode === 'saved'
                ? 'Continúa para elegir una cuenta guardada e indicar el monto. Si tu saldo en pesos cubre el monto, sale de COP sin conversión.'
                : 'Continúa para registrar los datos del beneficiario. Quedan guardados para el próximo envío.'}
            </p>
            <button
              type="button"
              className="enviar-hub__btn-p"
              onClick={() => startColombia(accountMode)}
            >
              {accountMode === 'saved' ? 'Continuar · Enviar a Colombia' : 'Continuar · Registrar cuenta'}
            </button>
          </div>
        </section>
      )}

      {dest === 'ext' && (
        <section className="enviar-hub__step-block">
          <h2 className="enviar-hub__step-heading">Paso 2 · ¿Cuenta lista o nueva?</h2>
          <p className="enviar-hub__step-sub">Banco en el exterior · USA / Europa / México / Brasil.</p>

          <div className="enviar-hub__fee-strip">
            <div className="enviar-hub__fee-chip">ACH · a menudo sin comisión en UI</div>
            <div className="enviar-hub__fee-chip">WIRE / otros · fee según riel y país</div>
          </div>

          <div className="enviar-hub__choice-toggle" role="tablist" aria-label="Tipo de cuenta">
            <button
              type="button"
              className={`enviar-hub__choice ${accountMode === 'saved' ? 'on' : ''}`}
              onClick={() => setAccountMode('saved')}
            >
              Usar cuenta registrada
            </button>
            <button
              type="button"
              className={`enviar-hub__choice ${accountMode === 'new' ? 'on' : ''}`}
              onClick={() => setAccountMode('new')}
            >
              Registrar cuenta nueva
            </button>
          </div>

          <div className="enviar-hub__panel fx-glass">
            <h3>{accountMode === 'saved' ? 'Tus cuentas en el exterior' : 'Registrar cuenta exterior'}</h3>
            <p className="enviar-hub__hint">
              {accountMode === 'saved'
                ? 'Continúa para elegir país, riel y una cuenta guardada.'
                : 'Continúa para elegir país y riel; luego registra la cuenta (ACH/WIRE, SEPA, SPEI o PIX).'}
            </p>
            <button
              type="button"
              className="enviar-hub__btn-p"
              onClick={() => startExterior(accountMode)}
            >
              {accountMode === 'saved' ? 'Continuar · Enviar al exterior' : 'Continuar · Registrar en exterior'}
            </button>
          </div>
        </section>
      )}
    </div>
  );
}
